// extracted by mini-css-extract-plugin
module.exports = {"drop_target":"DragDrop_drop_target__3fwxl","dnd_btn":"DragDrop_dnd_btn__3EPsq","container":"DragDrop_container__1Z9yd"};